{
  "chart": {
    "header": "Ramverk",
    "linkedDocumentsOutsideCategory": "Länkade dokument utanför denna kategori",
    "hideCategories": "Dölj kategorier",
    "groupByGraphs": "Gruppera efter grafer",
    "includeDrafts": "Inkludera icke publicerade dokument"
  }
}
